<template>
  <section class="CasinoGames GamesList GamesListGrid MsnRow" v-if="list">
    <h2 class="BoxTitle GamesContainerTitle">
      <a class="ComponentAnchor GameCategory Anchor Anchor " href="/de/cat/nur-bei-uns" title="Nur bei uns" id="CategoryGameList-Nur-bei-uns">
        Search Results</a>
    </h2>
    <div class="GamesSwipeable">
      <div class="GamesWrapper">
        <ul class="GamesListContainer HorizontalScrollBar HasLoadMoreButton List ListUnordered " v-infinite-scroll="fetchGames" infinite-scroll-disabled="busy" infinite-scroll-distance="5">
          <li class="ListGame ListItem GameTileContainer MasonryTile-1x1" v-for="game in list">
            <a v-on:click="openGame(game)" class="ComponentAnchor GamePlayNowButton Anchor " href="javascript:;" :title="game.name">
                  <span class="SvgIcon PlayButton">
                     <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
                        <path fill="#fff" d="M37.862 28.75l-15.32 9.913A.999.999 0 0121 37.824V18a1 1 0 011.543-.84l15.32 9.912a1.002 1.002 0 01-.001 1.679z"></path>
                        <path fill="#fff" d="M28 54c14.36 0 26-11.64 26-26S42.36 2 28 2 2 13.64 2 28s11.64 26 26 26zm0 2C12.536 56 0 43.464 0 28S12.536 0 28 0s28 12.536 28 28-12.536 28-28 28z"></path>
                     </svg>
                  </span>
            </a>
            <img class="GameThumb ListGameImage LazyImage" onerror="this.onerror=null;this.src = this.src.replace('.gif', '.jpg')" :alt="game.name" :src="game.thumbnail">
            <div class="GameProp GameVendor SubVendor" itemprop="author">{{ game.vendor.name }}</div>
            <div class="GameProp NewGame">NEU</div>
            <h3 class="GameTitle" itemprop="name">{{ game.name | slimiter(20) }}</h3>
          </li>
        </ul>

      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'resultList',
  props: ['list'],
  data () {
    return {
      t: this.$root.t,
      bsapi: bsapi
    }
  },
  methods: {
    openGame(g) {
      this.$parent.openGame(g);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/casino/widget/resultList.vue